'use strict';
export function Merchandise(url) {
  Object.defineProperties(this, {
    "currentPage": {
      get: function() {return this._currentPage},
      set: function(page) {
        if(!page) {
          throw new TypeError('currentPageプロパティ値が指定されていません');
        }
        this._currentPage = page;
      },
      enumerable: true
    },
    "lastPage": {
      get: function() {return this._lastPage;},
      set: function(page) {
        if(!page) {
          throw new TypeError('lastPageプロパティ値が指定されていません');
        }
        this._lastPage = page;
      },
      enumerable: true
    },
    "id": {
      get: function() {return this._id;},
      set: function(value) {
        if(!value) {
          throw new TypeError('idプロパティ値が指定されていません');
        }
        this._id = value;
      },
      enumerable: true
    },
    "items": {
      get: function() {return this._items;},
      set: function(items) {
        if(!items) {
          throw new TypeError('itemsプロパティ値が指定されていません');
        }
        this._items = items;
      },
      enumerable: true
    },
    "pagetype": {
      get: function() {return this._pagetype;},
      set: function(pagetype) {
        if(!pagetype) {
          throw new TypeError('pagetypeプロパティ値が指定されていません');
        }
        this._pagetype = pagetype;
      },
      enumerable: true
    },
    "url": {
      get: function() {return this._url;},
      set: function(value) {
        if(!value) {
          throw new TypeError('urlプロパティ値が指定されていません。');
        }
        this._url = value;
      },
      enumerable: true
    }
  });
  this.url = url;
};
Merchandise.prototype.init = function() {
  return this.request()
    .then(this.toJSON)
    .then(function(json) {
      this.pagetype = json.meta.type;
      this.currentPage = json.meta.nowpage;
      this.lastPage = json.meta.lastpage;
      if(/c(hara|ategory)|item/.test(this.pagetype)) {
        this.id = json.meta.id;
      }
      this.items = json.items;
      return this;
    }.bind(this))
    .catch(function(e) {
      var error = Object.create(null);
      error.status = 452;
      error.statusText = 'FAILED';
      error.message = '該当する関連商品情報が取得できませんでした。';
      error.reason = e.message;
      return Promise.reject(JSON.stringify(error));
    });
};
Merchandise.prototype.toJSON = function(response) {
  return response.json();
};
Merchandise.prototype.request = function() {
  return fetch(this.url, {mode: 'cors'});
};